const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_BASE_URL_DEV
    : process.env.REACT_APP_API_BASE_URL;

export async function fetchLiveTasks(env = 'memo') {
  const res = await fetch(`${API_BASE_URL}/liveTasks?env=${env}`);
  if (!res.ok) throw new Error('Failed to fetch live voice tasks');
  return res.json();
}
